export default __webpack_public_path__ + "static/media/leagueStatsBot.b86bf8ab.gif";